import script from "./TaskCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCardHeader.vue?vue&type=script&setup=true&lang=js"

import "./TaskCardHeader.vue?vue&type=style&index=0&id=4f19150c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f19150c"]])

export default __exports__